import { Box, List, type ListProps, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MainMenuItem } from '~/components/MainMenu/MainMenuItem';
import { MainMenuItemError } from '~/components/MainMenu/MainMenuItemError';
import { useAppSelector } from '~/application/hooks';
import { selectIsDrawerOpen } from '~/application/slice';
import type { NavigationItemType } from '~/types/navigation';

type MainMenuGroupProps = {
    item: NavigationItemType;
    selectedItems?: string | undefined;
    setSelectedItems?: (items: string | undefined) => void;
    selectedLevel?: null;
    setSelectedLevel?: (level: number) => void;
};

export const MainMenuGroup = ({ item }: MainMenuGroupProps) => {
    const drawerOpen = useAppSelector(selectIsDrawerOpen);

    return (
        <MainMenuGroupRoot
            open={drawerOpen}
            title={item.title}
            subheader={item.title && drawerOpen && (
                <Box sx={{ pl: 3, mb: 1.5 }}>
                    <Typography variant="subtitle2" color={'text.secondary'}>{item.title}</Typography>
                    {item.caption && <Typography variant="caption" color="secondary">{item.caption}</Typography>}
                </Box>
            )}
        >
            {item.children?.map((child) => {
                switch (child.type) {
                    case 'item':
                        return <MainMenuItem key={child.id} item={child} level={1} />;
                    default:
                        return <MainMenuItemError key={child.id} message="Stavka mora biti tipa 'item'." />
                }
            })}
        </MainMenuGroupRoot>
    );
};

const MainMenuGroupRoot = styled(List, {
    shouldForwardProp: (prop) => prop !== 'open' && prop !== 'title',
})<ListProps & { open: boolean; }>(
    ({ open, title, theme }) => ({
        marginTop: open && title ? theme.spacing(1.5) : 0,
        paddingTop: 0,
        paddingBottom: 0,
        zIndex: 0,
    })
);
